import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getOrganizationTemplate } from '@core/api/getOrganizationTemplate';
import { GetOrganizationTemplateResponse } from '@core/types/ApiResponses';

export type UseOrganizationSettingsResult = Omit<UseQueryResult<any, any>, 'data'> & {
  organizationTemplate: GetOrganizationTemplateResponse | null;
};

export const ORGANIZATION_TEMPLATE_QUERY_KEY = 'OrganizationTemplate';

const useOrganizationTemplate = (templateId: string): UseOrganizationSettingsResult => {
  const isEnabled = Boolean(templateId);
  const { data: organizationTemplate = null, ...rest } = useQuery({
    queryFn: () => getOrganizationTemplate(templateId),
    queryKey: [ORGANIZATION_TEMPLATE_QUERY_KEY, templateId],
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    cacheTime: 1000 * 60 * 60 * 24 * 1.5, // 36 hours
    enabled: isEnabled,
  });

  return { organizationTemplate, ...rest };
};

export default useOrganizationTemplate;
